import { ResourceDataType } from '@lib/types/nco-thank-you-page'

export const APP_DEVELOPMENT_MASTERCLASS: ResourceDataType[] = [
  {
    imageName: 'build-app-on-hunkable',
    title: 'How to build an app on Thunkable',
    ctaLink: 'https://www.youtube.com/watch?v=qN7z0-yghpA',
  },
  {
    imageName: 'healthcare-application-using-python',
    title: 'Create a healthcare application using Python',
    ctaLink: 'https://www.youtube.com/watch?v=lQqKbxl5-60',
  },
  {
    imageName: 'app-development-using-thunkable',
    title: 'App development using Thunkable',
    ctaLink: 'https://www.youtube.com/watch?v=kKBIflh-VLg',
  },
]

export const GAME_DEVELOPMENT_MASTERCLASS: ResourceDataType[] = [
  {
    imageName: 'underwater-game-building-using-sprites',
    title: 'Underwater game building using sprites',
    ctaLink: 'https://www.youtube.com/watch?v=BuPtzE1rOuU',
  },
  {
    imageName: 'covid-maze-game',
    title: 'Covid maze game using Scratch',
    ctaLink: 'https://www.youtube.com/watch?v=RAUyLOlau6Y',
  },
  {
    imageName: 'nature-game',
    title: 'Nature game using Scratch',
    ctaLink: 'https://www.youtube.com/watch?v=FCn73o8vlj0',
  },
]

export const WEB_DEVELOPMENT_MASTERCLASS: ResourceDataType[] = [
  {
    imageName: 'bmi-calculator',
    title: 'BMI calculator using Python',
    ctaLink: 'https://www.youtube.com/watch?v=KX0go_va6HM',
  },
  {
    imageName: 'healthcare-application-using-python',
    title: 'Create a healthcare application using Python',
    ctaLink: 'https://www.youtube.com/watch?v=lQqKbxl5-60',
  },
]

export const SCRATCH_PROGRAMMING_MASTERCLASS: ResourceDataType[] = [
  {
    imageName: 'scratch-programming',
    title: 'Scratch programming 3.0',
    ctaLink: 'https://www.youtube.com/watch?v=ZnHGbUK1xA4',
  },
  {
    imageName: 'scratch-programming',
    title: 'Control and operator blocks',
    ctaLink: 'https://www.youtube.com/watch?v=91txGylc-84',
  },
  {
    imageName: 'scratch-programming',
    title: 'Application and implementation of AI using Scratch',
    ctaLink: 'https://www.youtube.com/watch?v=owFJxgKB5Hg',
  },
  {
    imageName: 'scratch-programming',
    title: 'Learn the concepts of functions and variables',
    ctaLink: 'https://www.youtube.com/watch?v=wv7teOeM1JY',
  },
  {
    imageName: 'scratch-programming',
    title: 'Learn the concept of blocks and sprites',
    ctaLink: 'https://www.youtube.com/watch?v=cHTNVJRZqZY',
  },
]

export const ANIMATION_MASTERCLASS: ResourceDataType[] = [
  {
    imageName: 'building-animation',
    title: 'How to create an animation on the Scratch platform',
    ctaLink: 'https://www.youtube.com/watch?v=6WB1UsI-R78',
  },
]

export const QUICK_REFRESHER_VIDEO: ResourceDataType[] = [
  {
    imageName: 'coding-for-kids',
    title: 'Coding for kids: An introduction',
    ctaLink: 'https://www.youtube.com/watch?v=MGpT8rXRCf8',
  },
  {
    imageName: 'solar-system-project',
    title: 'Learn to build a solar system project using Scratch',
    ctaLink: 'https://www.youtube.com/watch?v=Fu9gKxxXfgo',
  },
  {
    imageName: 'introduction-to-loops',
    title: 'Introduction to loops in programming',
    ctaLink: 'https://www.youtube.com/watch?v=UgrZhRm1TC8',
  },
  {
    imageName: 'block-based-and-text-based-coding',
    title: 'Types of coding: Block-based and text-based coding',
    ctaLink: 'https://www.youtube.com/watch?v=PI5yZGqGRWI',
  },
  {
    imageName: 'five-best-free-platforms',
    title: '5 best free platforms for kids to learn to code',
    ctaLink: 'https://www.youtube.com/watch?v=lsCObbRG370',
  },
  {
    imageName: 'top-8-programming-languages',
    title: 'Top 8 programming languages for kids',
    ctaLink: 'https://www.youtube.com/watch?v=-cSRp_T1Mu0',
  },
]

export const FREE_WEBSITES_AND_PLATFORM: ResourceDataType[] = [
  {
    imageName: 'scratch',
    title: 'Scratch',
    ctaLink: 'https://scratch.mit.edu/',
  },
  {
    imageName: 'code-org',
    title: 'Code.org',
    ctaLink: 'https://studio.code.org/projects/',
  },
  {
    imageName: 'thunkable',
    title: 'Thunkable',
    ctaLink: 'https://thunkable.com/#/',
  },
  {
    imageName: 'replit',
    title: 'Replit',
    ctaLink: 'https://replit.com/',
  },
  {
    imageName: 'python',
    title: 'Python',
    ctaLink: 'https://www.python.org/',
  },
]

export const WATCH_VIDEOS_ON_THEMES: ResourceDataType[] = [
  {
    imageName: 'grade-1-4',
    title: 'Grade 1-4 themes video',
    ctaLink: 'https://youtu.be/FvAoWUOULuY',
  },
  {
    imageName: 'grade-5-8',
    title: 'Grade 5-8 themes video',
    ctaLink: 'https://youtu.be/DJBeXgoOQH0',
  },
  {
    imageName: 'grade-9-12',
    title: 'Grade 9-12 themes video',
    ctaLink: 'https://youtu.be/gK60jPl5BMo',
  },
]
